import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const RightArrowIcon = withSvgIcon(
    <g>
        <path d="M126 438.7l189.4-189.5L126.1 59.9l28.2-28.3L372 249.2 154.3 467z" />
    </g>
);
